declare global {
  interface Window {
    Clerk?: {
      session?: {
        getToken(): Promise<string>
      }
    }
  }
}

import axios from 'axios'
import { toast } from 'react-hot-toast'
import { getApiUrl } from '@/config/api'

const api = axios.create({
  baseURL: getApiUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use(async (config) => {
  try {
    const token = await window.Clerk?.session?.getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    } else {
      // No token available; ensure we don't send a stale header
      if (config.headers && 'Authorization' in config.headers) {
        delete (config.headers as Record<string, unknown>).Authorization
      }
    }
  } catch (err) {
    // Swallow token retrieval errors to avoid breaking unauthenticated flows
    if (config.headers && 'Authorization' in config.headers) {
      delete (config.headers as Record<string, unknown>).Authorization
    }
  }

  // Remove Content-Type header for FormData to let axios set it automatically with boundary
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status
    // Handle expired/invalid session or unauthorized globally
    if (status === 401 || status === 419) {
      // Sign out and send user to sign-in screen
      try {
        void (window as any).Clerk?.signOut?.()
      } catch (_) {
        // noop
      }
      // Best-effort redirect to root where <SignedOut> renders <SignIn>
      if (typeof window !== 'undefined') {
        window.location.href = '/'
      }
      return Promise.reject(error)
    }

    const message = error.response?.data?.error || 'An error occurred'
    toast.error(message)
    return Promise.reject(error)
  }
)

export default api